<template>
  <div class="main-layout">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="header-left">
        <router-link to="/" class="logo">
          <i class="el-icon-s-home"></i>
          网上报名
        </router-link>
      </div>
      <div class="header-right">
        <!-- <div class="search-box">
          <el-input
            placeholder="请输入关键词"
            suffix-icon="el-icon-search"
            v-model="keyword"
            class="search-keyword">
          </el-input> -->
        <!-- <input
            type="text"
            placeholder="请输入关键词"
            suffix-icon="el-icon-search" /> -->
        <!-- <i class="el-icon-search"></i> -->
        <!-- </div> -->

        <!-- <router-link to="/exam" class="nav-link">我的考试</router-link> -->
        <router-link to="/user/profile/setting" class="nav-link"
          >我的考试</router-link
        >

        <div class="user-info pointer">
          <!-- <i class="icon-user"></i>
          <span>张三</span> -->
          <el-dropdown
            class="avatar-container right-menu-item hover-effect"
            trigger="click">
            <div class="avatar-wrapper">
              <i class="el-icon-user"></i>
              {{ userInfo.username }}
              <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
            </div>
            <el-dropdown-menu slot="dropdown">
              <!-- <router-link :to="{ path: '/user/profile/setting' }">
                <el-dropdown-item>个人设置</el-dropdown-item>
              </router-link> -->
              <!-- <router-link
                :to="{ path: '/candidate-registrate/exam-documents' }">
                <el-dropdown-item>安全设置</el-dropdown-item>
              </router-link> -->
              <el-dropdown-item>
                <span @click="logout">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </header>

    <div class="main-container">
      <!-- 左侧菜单栏 -->
      <div>
        <aside class="sidebar">
          <div class="sidebar-title" @click="jumpToHome">
            <el-avatar
              :src="circleUrl"
              class="avatar mr-b-16 pointer"></el-avatar>
          </div>
          <div class="menu-list">
            <div
              v-for="(menuItem, index) in menuItems"
              :key="index"
              class="menu-item">
              <!-- <router-link
                :to="menuItem.path"
                :class="{ active: isActiveRoute(menuItem.path) }"
                @click="updateCurrentMenuPath(menuItem.path)">
                {{ menuItem.name }}
              </router-link> -->
              <div
                :class="{
                  active: isActiveRoute(menuItem.path),
                  active_pointer:
                    (isRead == true && loginType == 1) || loginType == 2,
                  noPointer: isRead == false && loginType == 1,
                }"
                @click="updateCurrentMenuPath(menuItem.path)">
                {{ menuItem.name }}
              </div>
            </div>
          </div>
        </aside>
        <div class="btn-box logout mr-t-16" @click="logout">退出系统</div>
      </div>

      <!-- 主内容区域 -->
      <main class="main-content">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
import { queryIsRead } from '@/api/applyForList';

export default {
  name: 'MainLayout',
  data() {
    return {
      menuItems: [],
      keyword: '',
      // userInfo: {},
      registrationNumber: [],
      regisNumberChoose: null,
      isRead: false,
      circleUrl:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      loginType: null,
      examId: null,
    };
  },
  watch: {
    registrationNumber: {
      handler: function (val, oldVal) {
        // console.log(val, 'registrationNumber变化:======');
        if (val && val.length > 0) {
          this.getIsRead();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // console.log('完整Vuex状态:', this.$store.state);
    // console.log('用户信息:', this.$store.state.userInfo);
    // if (this.$store.state.userInfo) {
    //   this.userInfo = JSON.parse(this.$store.state.userInfo);
    // }
  },
  computed:{
    userInfo(){
      if (this.$store.state.userInfo) {
        return  JSON.parse(this.$store.state.userInfo);
      }else if (localStorage.getItem('userInfo')){
        return JSON.parse(localStorage.getItem('userInfo'));
      }else {
        return {}
      }
    }
  },
  async created() {
    //await this.$store.dispatch('initCurrentMenuPath');
    this.fetchMenuData();
    // if (localStorage.getItem('userInfo')) {
    //   this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // }
    if (localStorage.getItem('registrationNumber')) {
      this.registrationNumber = JSON.parse(
        localStorage.getItem('registrationNumber')
      );
    }
    if (localStorage.getItem('regisNumberChoose')) {
      this.regisNumberChoose = JSON.parse(
        localStorage.getItem('regisNumberChoose')
      );
    }
    if (localStorage.getItem('examId')) {
      this.examId = JSON.parse(localStorage.getItem('examId'));
    }
    if (localStorage.getItem('loginType')) {
      this.loginType = JSON.parse(localStorage.getItem('loginType'));
    }
    // if (localStorage.getItem('loginType')) {
    //   this.loginType = JSON.parse(localStorage.getItem('loginType'));
    // }
  },
  methods: {
    async fetchMenuData() {
      try {
        const response = await this.$store.dispatch('getMenuList');
        if (response.success) {
          // 先设置菜单数据
          if (response && response.success) {
            this.menuItems = response.data; // 确保先更新菜单数据
          }

          // 然后处理路径跳转
          if (this.menuItems.length > 0) {
            const targetPath = this.menuItems[0].path;
            this.$store.commit('SET_CURRENT_MENU_PATH', targetPath);
            console.log(
              this.$store.state.nextMenuPath,
              'this.$store.state.nextMenuPath'
            );

            if (!this.$store.state.isUpdateMenu) {
              if (this.$route.path !== targetPath) {
                this.$router.push(targetPath);
              }
            } else {
              if (!this.$store.state.nextMenuPath) {
                if (this.$route.path !== this.$store.state.updateMenuPath) {
                  this.$router.push(this.$store.state.updateMenuPath);
                  this.$store.commit('SET_NEXT_MENU_PATH', null);
                }
              } else {
                if (this.$route.path !== this.$store.state.nextMenuPath) {
                  this.$router.push(this.$store.state.nextMenuPath);
                  this.$store.commit('SET_NEXT_MENU_PATH', null);
                }
              }
            }
          }
        }
        // if (response == undefined) {
        //   this.$message.warning('请先配置菜单');
        // }
      } catch (error) {
        // console.error('获取菜单数据失败:', error);
      }
    },
    isActiveRoute(path) {
      // 检查当前路由是否是该菜单项或其子路由
      // return this.$route.path.startsWith(path);
      if (!this.$store.state.isUpdateMenu) {
        return this.$store.state.currentMenuPath === path;
      } else {
        if (!this.$store.state.nextMenuPath) {
          return this.$store.state.updateMenuPath === path;
        } else {
          return this.$store.state.nextMenuPath === path;
        }
      }
    },
    updateCurrentMenuPath(path) {
      console.log(path,'//////////////554545')
      this.$store.commit('SET_UPDATE_MENU_PATH', path);
      this.$store.commit('SET_IS_UPDATE_MENU', true);
      if (this.isRead && this.$route.path !== path && (this.loginType == 1 || this.loginType == 3)) {
        console.log(11111);
        this.$router.push({ path: path });
      }
      if (this.loginType == 2) {
        console.log(22222);
        this.$router.push({ path: path });
      }
    },
    jumpToHome() {
      this.$router.push({ path: '/user/profile/setting' });
    },
    logout() {
      this.$confirm('此操作将退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store.dispatch('logout');
          this.$nextTick(()=>{
            this.$router.push('/login');
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
          })

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    //查询是否已读
    getIsRead() {
      if (!this.registrationNumber || this.registrationNumber.length == 0)
        return;
      queryIsRead({
        registrationNumber: this.regisNumberChoose
          ? this.regisNumberChoose
          : this.registrationNumber[this.registrationNumber.length - 1],
      }).then((res) => {
        console.log(res, 'read======');
        if (res.code == 200) {
          this.isRead = res.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-layout {
  min-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

.header {
  background-color: #333;
  padding: 0 20px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left .logo {
  color: white;
  text-decoration: none;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-home::before {
  content: '🏠';
}

.header-right {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 40%;
  /* background-color: pink; */
  /* gap: 20px; */
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box input {
  width: 240px;
  padding: 6px 30px 6px 12px;
  border: 1px solid #666;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.icon-search {
  position: absolute;
  right: 10px;
  color: #999;
}

.nav-link {
  color: #fff;
  font-size: 18px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
}

.account-btn {
  background-color: #f56c6c;
  color: white;
  text-decoration: none;
  padding: 6px 16px;
  border-radius: 4px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
}

.icon-home::before {
  content: '🏠';
}

.icon-search::before {
  content: '🔍';
}

.icon-star::before {
  content: '⭐';
}

.icon-user::before {
  content: '👤';
}

/* 悬停效果 */
.nav-link:hover {
  // color: #409eff;
  font-weight: 700;
}

.account-btn:hover {
  background-color: #f78989;
}

.main-container {
  flex: 1;
  display: flex;
  align-items: flex-start; /* 确保子元素从顶部对齐,从而实现左右两侧不等高 */
  background-color: #f5f5f5;
  padding: 16px;
  gap: 16px;
}

.sidebar {
  width: 200px;
  background-color: white;
  padding: 0;
  /* flex-shrink: 0; 防止左侧菜单栏收缩 */
}

.sidebar-title {
  /* padding: 16px 24px; */
  font-size: 16px;
  color: #333;
  font-weight: 500;
  /* border-bottom: 1px solid #eee; */
  height: 120px;
  line-height: 120px;
  text-align: center;
  padding: 16px 24px;
  .avatar {
    display: block;
    width: 90px;
    height: 90px;
    margin: 0 auto;
  }
}

.menu-list {
  padding: 8px 0;
}

.menu-item {
  padding: 0;
  text-align: center;
}

.menu-item a {
  display: block;
  padding: 12px 24px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
  font-size: 14px;
}
.menu-item div {
  display: block;
  padding: 12px 24px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
  font-size: 14px;
  // cursor: pointer;
}

.menu-item a:hover,
.menu-item a.active {
  color: #1890ff;
  background-color: #e6f7ff;
}

.menu-item div:hover,
.menu-item div.active {
  color: #1890ff;
  background-color: #e6f7ff;
}

.active_pointer {
  cursor: pointer;
  &:hover {
    cursor: pointer;
  }
  &:active {
    cursor: pointer;
  }
}
.noPointer {
  cursor: not-allowed;
  &:hover {
    cursor: not-allowed;
  }
  &:active {
    cursor: not-allowed;
  }
}

.main-content {
  flex: 1;
  background-color: white;
  border-radius: 4px;
  /* min-height: 0; 确保内容区域可以收缩 */
}

.search-keyword {
  ::v-deep .el-input__inner {
    border-radius: 20px;
    background-color: #333;
    outline: none;
    border-color: #b7b4b4;
  }
}

.logout {
  cursor: pointer;
  color: $--color-primary;
  border: 1px solid $--color-primary;
  &:hover {
    background-color: $--color-primary;
    color: #fff;
  }
}
::v-deep .el-dropdown {
  color: #fff;
  font-size: 18px;
}
</style>
